<template>
  <div class="adm-content-item" :class="[`ui--${type}`]" v-if="value">
    <div class="adm-content-item__title">
      <slot name="checkbox"></slot>
      <h5 style="color:#3C3C3C" :title="`舆情编号：${value.id}`">{{ !!value.title ? value.title : "" }}</h5>
      <a :href="value.url" target="_blank" rel="noopener noreferrer">
        <small class="adm-content-item__type" title="在新窗口打开">
          <iv-icon type="md-open" size="16" />
        </small>
      </a>
      <span style="font-weight:normal;mergin-left:50px">（发布于{{ value.postTime | timesify }}）</span>
      <span class="adm-split">
        <a href="javascript:;" v-if="showLogButton" @click="$operationLog.show({ type:'sentiment', sentimentType:'listed', sentimentId: value.id })">
          <small class="adm-content-item__type">
            <iv-icon type="md-search" size="12" />
          </small>
          <span>查看日志</span>
        </a>
        <a v-if="showJumpEditBUtton" title="在新窗口进入舆情管理中编辑" href="javascript:;" @click="$emit('jumpToEdit')">
          跳转编辑<small class="adm-content-item__type">
            <iv-icon type="md-open" size="12" />
          </small>
        </a>
      </span>

      <template v-if="type!='audit'">
        <span class="item_edit" @click="shownTitleModal" v-rbac-allow="['publicSentiment', 'edit']"><iv-icon type="ios-create-outline" size="16" style="vertical-align:text-bottom" />修改标题</span>
        <span class="adm-split pull-right">
          <span class="adm-content-item__read" v-if="is_confirm == 1">已收录</span>
          <span class="adm-content-item__exclude" v-else-if="is_confirm == 2">已排除</span>
          <span class="adm-content-item__not" v-else>未收录</span>
          <span class="t-s">
            <iv-poptip v-if="value.audit==2" trigger="hover" title="审核批注" placement="left">
              <iv-icon type="ios-information" size="12" style="color:#2d8cf0"></iv-icon>
              <div slot="content" v-html="value.comment.replace(/\n/g,'<br>')"></div>
            </iv-poptip>
            {{ ['','未审核','不通过','已通过'][value.audit] }}
          </span>
        </span>
      </template>
      <template v-else>
        <span class="pull-right">
          <span class="adm-split">
            <!-- <span>公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }}</span>
            </span>
            <span>关联类型：<span class="t-s">{{ relateCompanyTypeText }}</span>
            </span> -->
            <span class="t-s">
              <iv-poptip v-if="value.audit==2" trigger="hover" title="审核批注" placement="left">
                <iv-icon type="ios-information" size="12" style="color:#2d8cf0"></iv-icon>
                <div slot="content" v-html="value.comment.replace(/\n/g,'<br>')"></div>
              </iv-poptip>
              {{ ['','未审核','不通过','已通过'][value.audit] }}
            </span>
            <slot name="buttons"></slot>
          </span>
        </span>
      </template>
    </div>
    <div class="adm-content-item__tip">
      <span>
        公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }} </span>
        <a  v-if="type!='audit'" href="javascript:;" class="item_edit" @click="$emit('companyEdit')" v-rbac-allow="['publicSentiment', 'edit']"><iv-icon type="ios-create-outline" size="16" style="vertical-align:text-bottom" /></a>
      </span>
      <span>
        <span>关联类型：</span>
        <iv-dropdown v-if="type!='audit'" class="t-s" @on-click="relateCompanyTypeChange">
          <a href="javascript:;">{{ relateCompanyTypeText }} <iv-icon type="ios-arrow-down" /></a>
          <iv-dropdown-menu slot="list">
            <iv-dropdown-item name="母公司">母公司</iv-dropdown-item>
            <iv-dropdown-item name="子公司">子公司</iv-dropdown-item>
          </iv-dropdown-menu>
        </iv-dropdown>
        <span class="t-s" v-else>{{ relateCompanyTypeText }}</span>
      </span>
      <span>
        数据来源：<span class="t-s">{{ value.source }}</span>
      </span>
    </div>
    <div class="adm-content-item__detail">
      <div class="adm-content-item__meta meta-01">
        <div>
          公司名称：<span class="t-s">{{ value.companyInfo.abbreviation }} </span>
          <a v-if="type!='audit'" href="javascript:;" class="item_edit" @click="$emit('companyEdit')" v-rbac-allow="['publicSentiment', 'edit']"><iv-icon type="ios-create-outline" size="16" style="vertical-align:text-bottom" /></a>
        </div>
        <div>
          <span>关联类型：</span>
          <iv-dropdown v-if="type!='audit'" class="t-s" @on-click="relateCompanyTypeChange">
            <a href="javascript:;">{{ relateCompanyTypeText }} <iv-icon type="ios-arrow-down" /></a>
            <iv-dropdown-menu slot="list">
              <iv-dropdown-item name="母公司">母公司</iv-dropdown-item>
              <iv-dropdown-item name="子公司">子公司</iv-dropdown-item>
            </iv-dropdown-menu>
          </iv-dropdown>
          <span class="t-s" v-else>{{ relateCompanyTypeText }}</span>
        </div>
        <div>
          数据来源：<span class="t-s">{{ value.source }}</span>
        </div>
      </div>
      <div class="adm-content-item__meta" v-if="type!='audit'">
        <div>
          关键词：<span class="t-s">{{ value.keywords }}</span>
        </div>
        <iv-poptip trigger="hover" title="命中内容：" width="350" placement="top-start">
          <div class="item_section">命中内容：<span class="t-s" v-html="hightLight"></span></div>
          <div slot="content" style="white-space: normal;word-break: break-all;"><span v-html="hightLight"></span></div>
        </iv-poptip>
      </div>
      <div class="adm-content-item__meta">
        <div>
          二级指标：<span class="t-s">{{ value.secondTargetName }}</span>
        </div>
        <div>
          三级指标：<span class="t-s">{{ value.thirdTargetName }}</span>
        </div>
      </div>
      <div class="adm-content-item__meta">
        <div>
          情感类型：<span class="t-s">{{ value.sentiment_new }}</span>
        </div>
        <div>
          <div>评分：<span class="t-s" style="font-size:18px;">{{ value.score }}</span></div>
          <div>总得分：<span class="t-s" style="font-size:18px;">{{ value.weightedScore }}</span></div>
        </div>
        <div v-if="type!='audit'">
          <iv-poptip trigger="hover" title="得分情况" width="350" placement="left">
            <span>得分情况：</span>
            <span class="t-a">{{ value.dimensionInfo.some(item => item.dimensionScore > 0) ? "已评分" : "未评分" }}</span>
            <div slot="content" class="adm-flex-group ui-wrap">
              <div class="ui-grow" style="width:50%;padding:0 10px;" v-for="dimension in value.dimensionInfo" :key="dimension.dimensionId">
                {{ dimension.dimension }}({{ dimension.dimensionScore }})<br />
                <iv-progress :percent="(dimension.dimensionScore / dimension.dimensionWeight) * 100" hide-info :stroke-width="6" />
              </div>
            </div>
          </iv-poptip>
        </div>
        <div v-else>
          <div class="adm-flex-group ui-wrap">
            <div
              class="ui-grow"
              v-for="dimension in value.dimensionInfo"
              :key="dimension.dimensionId">
              <div style="width:150px">
                {{ dimension.dimension }}({{ dimension.dimensionScore }})<br />
                <iv-progress :percent=" (dimension.dimensionScore / dimension.dimensionWeight) * 100" hide-info :stroke-width="6" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <iv-modal :mask-closable="false" title="修改标题" width="450" :closable="false" v-model="titleModal" @on-cancel="titleModal = false">
      <iv-form :model="formValidate" :rules="ruleValidate" ref="formValidate" label-position="top" inline>
        <iv-form-item label="标题" prop="title">
          <iv-input type="text" v-model="formValidate.title" placeholder="请输入标题" style="width:400px"></iv-input>
        </iv-form-item>
      </iv-form>
      <iv-button type="text" size="large" slot="footer" @click="titleModal = false">取消</iv-button>
      <iv-button type="primary" size="large" slot="footer" @click="update">确定</iv-button>
    </iv-modal>
  </div>
</template>
<style lang="scss" scoped>
.adm-content-item {
  font-size: 12px;
  padding: 15px 12px;
  color: #999999;
  &__title {
    font-size: 12px;
    margin-bottom: 0.5em;
    h5{
      display: inline;
      font-size: 14px;
    }
    .item_edit {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  &__detail {
    display: flex;
    justify-content: space-between;
    margin: 0 -15px;
    > *{
      padding: 0 15px;
    }
  }
  &__meta {
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
    &::after {
      content: "";
      width: 1px;
      border-right: 1px solid #dddddd;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
    > div {
      line-height: 22px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      display: block;
    }
    .negative > .ivu-select >>> .ivu-select-selection {
      background: #ed4c4c;
    }
    .positive > .ivu-select >>> .ivu-select-selection {
      background: #33ab15;
    }
    .item_section {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box; //作为弹性伸缩盒子模型显示。
      -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
      -webkit-line-clamp: 3; //显示的行
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }
  &__buttons {
    opacity: 1;
    transition: opacity 0.5s ease-out;
    a,
    button {
      margin-left: 0.625em;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  &__type {
    // vertical-align: middle;
    margin-left: 7px;
  }
  &__read {
    color: #2d8cf0;
  }
  &__exclude {
    color: #ed4c4c;
  }
  &__not {
    color: #666;
  }
  .t-s {
    color: #666;
  }
  .t-a {
    color: #2d8cf0;
    text-decoration: underline;
  }
  .meta-01{
    display: block;
    @media screen and (max-width:1366px) {
      display: none;
    }
  }
  &__tip{
    display: none;
    margin-bottom: 1em;
    > span{
      margin-right:10px;
    }
    @media screen and (max-width:1366px) {
      display: block;
    }
  }

  &.ui--draft{
    .adm-content-item__meta {
      flex-shrink: 0;
      &:nth-child(1) {
        flex-grow: 0;
        min-width: 160px;
      }
      &:nth-child(2) {
        flex-shrink: 1;
      }
      &:last-child {
        flex-grow: 0;
      }
      &:nth-last-child(3) {
        min-width: 350px;
        flex-grow: 0;
        flex-shrink: 1;
        @media screen and (max-width:1366px) {
          min-width: 250px;
        }
      }
      &:nth-last-child(2) {
        width: 130px;
      }
      &:last-child,
      &:nth-last-child(2) {
        flex-grow: 0;
        &::after {
          display: none;
        }
      }
    }
  }
  &.ui--audit{
    .adm-content-item__meta {
      &:nth-child(1) {
        flex-grow: 0;
        width: 150px;
      }
      &:nth-child(2) {
        flex-grow: 0;
        width: 250px;
      }
      &:last-child{
        &::after {
          display: none;
        }
      }
    }
  }
}
</style>
<script>
const options = {
  sentiment_list: [
    { id: "负面", title: "负面" },
    { id: "正面", title: "正面" }
  ]
};
export default {
  props: {
    value: Object,
    type: {
      type: String,
      default: "draft" //可选：draft, audit；draft为收录入前的草稿，audit为收录后的样式
    },
    is_confirm: {
      type: Number,
      default: 0
    },
    showLogButton: Boolean,
    showJumpEditBUtton: Boolean
  },
  data() {
    return {
      options: {
        ...options
      },
      titleModal: false,
      companyModal: false,
      formValidate: {title:""},
      ruleValidate: {
        title: [{ required: true, message: "请输入标题", trigger: "change" }]
      }
    };
  },
  methods: {
    find(arr, val, field = "id") {
      return arr.find(item => item[field] == val) || {};
    },
    async update() {
      if (!this.$refs.formValidate.validate) return;
      this.$emit("title", { id: this.value.id, title: this.formValidate.title });
      this.titleModal = false;
    },
    shownTitleModal() {
      this.titleModal = true;
      this.formValidate.title = this.value.title;
    },
    relateCompanyTypeChange(name){
      this.$emit("relateCompanyType", {
        id: this.value.id,
        relateCompanyType:['母公司','子公司'].indexOf(name)
      })
    }
  },
  computed: {
    hightLight() {
      var text = this.value.negativeSection;
      switch (this.value.keywords) {
        case "无":
          break;

        default:
          var arr = this.value.keywords.split(";");
          arr.forEach(item => {
            if(!item.trim()) return ""
            let replaceReg = new RegExp(item, "g");
            let replaceString = '<span class="search-text">' + item + "</span>";
            text = text.replace(replaceReg, replaceString);
          });
          break;
      }
      console.log(this.value.keywords)
      console.log(text)
      return text;
    },
    relateCompanyTypeText(){
      return ['母公司','子公司'][this.value.relateCompanyType]
    }
  }
};
</script>
